import { parseDateValue } from "@/shared/components/CalendarDateField";
import { CompleteHistorySection } from "@/features/patient/clinical-history/components/CompleteHistoryView";
import { useClinicalHistory } from "@/features/patient/clinical-history/utils/adaptClinicalHistory";
import { usePatientProfile } from "@/portals/patient/context/PatientProfileContext";
import { useFamily } from "@/portals/patient/context/FamilyContext";
import { useSearchFocusParam } from "@/shared/hooks/useSearchFocus";

function ageFrom(dateOfBirth: string | null): number | null {
  if (!dateOfBirth) return null;
  const dob = parseDateValue(dateOfBirth);
  if (Number.isNaN(dob.getTime())) return null;
  const diff = Date.now() - dob.getTime();
  return Math.abs(new Date(diff).getUTCFullYear() - 1970);
}

export function CompleteHistoryPage() {
  const { allergies, conditions, procedures, immunizations, examAndVitals, familyHistory, isLoading } = useClinicalHistory();
  const { profile } = usePatientProfile();
  const { activeDependent } = useFamily();
  const focus = useSearchFocusParam();

  const name = activeDependent
    ? activeDependent.name
    : `${profile.firstName} ${profile.lastName}`.trim() || "You";
  const age = ageFrom(profile.dateOfBirth);
  const metaParts = [
    profile.gender ? profile.gender.charAt(0).toUpperCase() + profile.gender.slice(1) : null,
    age != null ? `Age ${age}` : null,
  ].filter(Boolean);

  const conditionCount = conditions.filter((c) => c.status !== "resolved").length;

  return (
    <CompleteHistorySection
      allergies={allergies}
      conditions={conditions}
      procedures={procedures}
      immunizations={immunizations}
      examAndVitals={examAndVitals}
      familyHistory={familyHistory}
      isLoading={isLoading}
      self={{
        name,
        meta: metaParts.join(" · "),
        conditionCount,
      }}
      focus={focus}
    />
  );
}
